
      const metaTagsScript = document.createElement('script')
      metaTagsScript.src = `${import.meta.env.BASE_URL}meta-tags.js`
      document.head.appendChild(metaTagsScript)
    